import type { ReactNode } from 'react';
import './ThreadHeader.css';

export type ThreadHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  leading?: ReactNode;
  backButton?: ReactNode;
  status?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function ThreadHeader({
  title,
  subtitle,
  leading,
  backButton,
  status,
  actions,
  className = '',
}: ThreadHeaderProps) {
  return (
    <div className={`thread-header ${className}`.trim()}>
      {backButton && <div className="thread-header__back">{backButton}</div>}
      {leading && <div className="thread-header__leading">{leading}</div>}
      <div className="thread-header__content">
        <div className="thread-header__title">{title}</div>
        {subtitle && <div className="thread-header__subtitle">{subtitle}</div>}
      </div>
      {status && <div className="thread-header__status">{status}</div>}
      {actions && <div className="thread-header__actions">{actions}</div>}
    </div>
  );
}
